import { Box, SxProps } from '@mui/material'
import { t } from 'i18next'
import { FC } from 'react'

import { useAuth } from '@app/context/auth'

export const GOOGLE_PLAY_ICON_URL =
  'https://cdn-tt.teamteach.com/wp-content/uploads/2023/12/07203707/download-on-google-play-Team-Teach-App-cropped.jpg'

export const APP_STORE_ICON_URL =
  'https://cdn-tt.teamteach.com/wp-content/uploads/2023/12/07203813/download-on-the-app-store-Team-Teach-App-cropped-e1701981637960.jpg'

export const APP_STORE_DOWNLOAD_LINK =
  'https://apps.apple.com/gb/app/team-teach-connect/id6471555452'

export const GOOGLE_PLAY_DOWNLOAD_LINK =
  'https://play.google.com/store/apps/details?id=com.teamteachknowledgehub.android&pcampaignid=web_share'

export const MobileAppDownloadCta: FC<{ sx?: SxProps }> = ({ sx }) => {
  const {
    acl: { isAustralia },
  } = useAuth()

  if (isAustralia()) return

  return (
    <Box
      width={'100%'}
      flexDirection={'row'}
      justifyContent={'center'}
      sx={sx}
      display="flex"
      gap={2}
    >
      <Box
        sx={{
          padding: 1,
          borderRadius: '5px',
          backgroundColor: 'black',
          display: 'grid',
          placeItems: 'center',
          width: '100%',
        }}
      >
        <a
          href={GOOGLE_PLAY_DOWNLOAD_LINK}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: 'grid', placeItems: 'center' }}
        >
          <img
            alt={t('mobile-app-panel.google-play-alt')}
            width={'100%'}
            src={GOOGLE_PLAY_ICON_URL}
            data-testid="google-play-download"
          />
        </a>
      </Box>
      <Box
        sx={{
          padding: 1,
          borderRadius: '5px',
          backgroundColor: 'black',
          display: 'grid',
          placeItems: 'center',
          width: '100%',
        }}
      >
        <a
          href={APP_STORE_DOWNLOAD_LINK}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: 'grid', placeItems: 'center' }}
        >
          <img
            alt={t('mobile-app-panel.app-store-alt')}
            src={APP_STORE_ICON_URL}
            width={'100%'}
            data-testid="app-store-download"
          />
        </a>
      </Box>
    </Box>
  )
}
